module.exports = __webpack_public_path__ + "static/img/320.6cbb0f17.png";